var _path, _g, _circle, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 140C108.66 140 140 108.66 140 70C140 31.3401 108.66 0 70 0C31.3401 0 0 31.3401 0 70C0 108.66 31.3401 140 70 140Z",
    fill: "#EDEDED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1173_23155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.625 0H32.375C29.9588 0 28 2.14125 28 4.78261V105.217C28 107.859 29.9588 110 32.375 110H107.625C110.041 110 112 107.859 112 105.217V4.78261C112 2.14125 110.041 0 107.625 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 25,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 43,
    width: 56,
    height: 6,
    rx: 3,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 61,
    width: 56,
    height: 6,
    rx: 3,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 79,
    width: 56,
    height: 6,
    rx: 3,
    fill: "#EDEDED"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96.9984,
    cy: 54.9984,
    r: 17.4984,
    stroke: "#B6B6B6",
    strokeWidth: 5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 20,
    rx: 2.5,
    transform: "matrix(0.766044 -0.642788 0.642724 0.766098 107.596 70.0996)",
    fill: "#B6B6B6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1173_23155",
    x: 22,
    y: 0,
    width: 96,
    height: 122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.750694 0 0 0 0 0.758854 0 0 0 0 0.783333 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1173_23155"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1173_23155",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyData);
export default __webpack_public_path__ + "static/media/empty-data.121f9abaeeb448ec606b9a36a6399ac6.svg";
export { ForwardRef as ReactComponent };